module.exports = __webpack_public_path__ + "static/img/9.858974b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/9.png
// module id = FWDp
// module chunks = 35